const data = [
  {
    id: 1,
    title: "magnam facilis autem",
    image: "https://www.aroundweb.it/react/dark-mode/01.jpg",
    body: "quia et suscipit suscipit recusandae consequuntur expedita et cum reprehenderit molestiae ut ut quas totam nostrum rerum est autem sunt rem eveniet architecto",
  },
  {
    id: 2,
    title: "qui est esse",
    image: "https://www.aroundweb.it/react/dark-mode/02.jpg",
    body: "est rerum tempore vitae sequi sint nihil reprehenderit dolor beatae ea dolores neque fugiat blanditiis voluptate porro vel nihil molestiae ut reiciendis qui aperiam non debitis possimus qui neque nisi nulla",
  },
  {
    id: 3,
    title: "ea molestias quasi",
    image: "https://www.aroundweb.it/react/dark-mode/03.jpg",
    body: "et iusto sed quo iure voluptatem occaecati omnis eligendi aut ad voluptatem doloribus vel accusantium quis pariatur molestiae porro eius odio et labore et velit aut",
  },
  {
    id: 4,
    title: "eum et est occaecati",
    image: "https://www.aroundweb.it/react/dark-mode/04.jpg",
    body: "ullam et saepe reiciendis voluptatem adipisci sit amet autem assumenda provident rerum culpa quis hic commodi nesciunt rem tenetur doloremque ipsam iure quis sunt voluptatem rerum illo velit",
  },
  {
    id: 5,
    title: "nesciunt quas odio",
    image: "https://www.aroundweb.it/react/dark-mode/05.jpg",
    body: "repudiandae veniam quaerat sunt sed alias aut fugiat sit autem sed est voluptatem omnis possimus esse voluptatibus quis est aut tenetur dolor neque",
  },
  {
    id: 6,
    title: "nesciunt quas odio",
    image: "https://www.aroundweb.it/react/dark-mode/06.jpg",
    body: "repudiandae veniam quaerat sunt sed alias aut fugiat sit autem sed est voluptatem omnis possimus esse voluptatibus quis est aut tenetur dolor neque",
  },
  {
    id: 7,
    title: "nesciunt quas odio",
    image: "https://www.aroundweb.it/react/dark-mode/07.jpg",
    body: "repudiandae veniam quaerat sunt sed alias aut fugiat sit autem sed est voluptatem omnis possimus esse voluptatibus quis est aut tenetur dolor neque",
  },
  {
    id: 8,
    title: "nesciunt quas odio",
    image: "https://www.aroundweb.it/react/dark-mode/08.jpg",
    body: "repudiandae veniam quaerat sunt sed alias aut fugiat sit autem sed est voluptatem omnis possimus esse voluptatibus quis est aut tenetur dolor neque",
  },
  {
    id: 9,
    title: "nesciunt quas odio",
    image: "https://www.aroundweb.it/react/dark-mode/09.jpg",
    body: "repudiandae veniam quaerat sunt sed alias aut fugiat sit autem sed est voluptatem omnis possimus esse voluptatibus quis est aut tenetur dolor neque",
  },

];

export default data;
